<template>
  <div class="sidebar_mobile">
    <!-- 侧边菜单 -->
    <van-popup v-model="show" position="right" class="sidebar_menu">
      <div class="sidebar_menu_panel">
        <div class="menu_panel_title">
          <img src="@/assets/sidebar/box.png" alt />
        </div>
        <ul class="menu_panel_links">
          <li
            class="link_item"
            @click="handleLink(item.id, item.is_type)"
            v-for="item in links"
            :key="item.name"
          >
            {{ item.name }}
            <span class="arrow"></span>
          </li>
          <li class="link_item" @click="changeLane">
            <img src="@/assets/sidebar/icon1_2.png" alt />
            {{ $route.params.lang === "en" ? "ZH" : "EN" }}
            <span class="arrow"></span>
          </li>
        </ul>
        <!-- 其他菜单操作 -->
        <ul class="menu_panel_links other_oprate">
          <li class="link_item" @click.stop.prevent="handleCopy('summit@blockchainlabs.org')">
            <img src="@/assets/icon/message.webp" alt />
            {{ $route.params.lang == "zh" ? "邮箱" : "E-mail" }}
            <span class="arrow"></span>
          </li>
          <li class="link_item" @click="clickLink('https://weibo.com/u/6289408183')">
            <img src="@/assets/icon/weibo.webp" alt />
            {{ $route.params.lang == "zh" ? "微博" : "MicroBlog" }}
            <span class="arrow"></span>
          </li>
          <li
            class="link_item link_item_position"
            @click="clickLink('https://www.blockchainlabs.org/#/home')"
          >
            <img src="@/assets/icon/house.webp" alt />
            <span>
              {{
              $route.params.lang == "zh"
              ? "万向区块链实验室"
              : "WANGXIANG BLOCKCHAIN LABS"
              }}
            </span>
            <span class="arrow"></span>
          </li>
          <li class="link_item2">
            <div class="link_item_position">
              <img class="icon" src="@/assets/icon/wechart.webp" alt />
              <span>
                {{
                $route.params.lang == "zh" ? "微信公众号" : "WECHAT OFFICIAL ACCOUNT"
                }}
              </span>
              <!-- <span class="arrow" ></span> -->
            </div>
            <div class="wx_code">
              <img src="@/assets/live/ma.png" alt />
            </div>
          </li>
        </ul>
        <!-- 地址 -->
        <div class="active_address">
          <div class="address_tit">
            <img src="@/assets/sidebar/icon6_2.png" alt />
            <span>{{ $t("Eventaddress") }}</span>
          </div>
          <div class="address_det">
            <p>{{ $t("address") }}</p>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 头部菜单 -->
    <div class="sidebar_mobile_icon" @click="handelbanner()">
      <img src="@/assets/sidebar/box.png" alt />
    </div>
    <div class="sidebar_mobile_menu" @click="handleShowMenu">
      <div class="sidebar_mobile_menu_line"></div>
      <div class="sidebar_mobile_menu_line"></div>
      <div class="sidebar_mobile_menu_line"></div>
    </div>

    <BulletFrame v-if="ifyjjb" @show="showPh" />
  </div>
</template>

<script>
import popup from "vant/lib/popup/index";
import "vant/lib/popup/style/index";
import { Toast } from "vant";
import "vant/es/toast/style";
import { BusCooperation } from "@/utils/links";
import { getWindowSize } from "@/utils/index";
import { setStatisticList } from "@/components/setStatistic";
import { changeUrlLang } from "@/utils/index";
import BulletFrame from "../components/BulletFrame.vue";

export default {
  name: "AsideLayoutSide",
  components: {
    vanPopup: popup,
    BulletFrame
  },
  props:{
    navList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      show: false,
      ifyjjb: false,
    };
  },
  mounted() {
    
  },
  computed: {
    links() {
      return this.navList || [];
    }
  },
  methods: {
    clickLink(url) {
      window.location.href = url;
    },
    handelbanner() {
      this.$router.replace({
        name: "ArrNoRepeat",
        params: {
          lang: this.$route.params.lang
        }
      });
    },
    handleLink(id, type) {
      this.show = false;
      if (type == 1) {
        if (id == 14) {
          setStatisticList("3", getWindowSize() <= 640 ? "2" : "1");
          // let zhurl =
          //   "https://9424105689699.huodongxing.com/event/7808935150100";
          // let enurl =
          //   "https://9424105689699.huodongxing.com/event/7808935150100";

          let zhurl = "https://9424105689699.huodongxing.com/event/4864962337700";
          let enurl = "https://9424105689699.huodongxing.com/event/4865379008511";
          window.open(
            this.$route.params.lang == "zh" ? zhurl : enurl,
            "_blank"
          );
        }
        if(id==26){
          window.open(
            BusCooperation,
            "_blank"
          );
        }
        this.$router.push({
          name:
            id == 4
              ? "Partners"
              : id == 3
              ? "SideEvent"
              : id == 2
              ? "Agenda"
              : id == 1
              ? "Speakers"
              : id == 15
              ? "Live"
              : "LiveReview"
        });
      } else {
        // Toast({
        //   message:
        //     this.$route.params.lang == "zh" ? " 敬请期待 " : "Coming soon",
        //   className: "Zindex"
        // });
        this.ifyjjb = true;
      }
    },
    showPh(flag) {
      this.ifyjjb = flag;
    },
    handleShowMenu() {
      this.show = !this.show;
    },
    changeLane() {
      let l = this.$route.params.lang || "zh";
      let nextLang = this.$route.params.lang === "en" ? "zh" : "en";
      sessionStorage.setItem("Language", nextLang == "zh" ? "cn" : "en");

      changeUrlLang(l);
    },
    handleCopy(text) {
      // 获取要复制的文本
      const textToCopy = text;

      // 创建一个临时的 textarea 元素
      const textarea = document.createElement("textarea");
      // 设置 textarea 为不可见
      textarea.style.position = "fixed"; // 可以避免在页面上滚动
      textarea.style.opacity = 0;
      // 设置 textarea 的值
      textarea.value = textToCopy;
      // 将 textarea 添加到 body 中
      document.body.appendChild(textarea);
      // 选中 textarea 中的文本
      textarea.select();

      try {
        // 尝试复制文本到剪贴板
        document.execCommand("copy");
        // 可以选择在这里添加一些提示信息，比如使用 ElementUI 的 Message 组件
        // 注意：如果你使用了 Vuex 或其他状态管理，你可能需要另一种方式来访问 Message 组件
        // 这里为了简单起见，我们直接使用 alert
        Toast({
          message: " 已复制到剪贴板 ",
          className: "Zindex"
        });
      } catch (err) {
        // 复制失败
        console.error("复制失败:", err);
      }

      // 移除 textarea
      document.body.removeChild(textarea);
    }
  }
};
</script>
<style lang="less" scoped>
.sidebar_mobile {
  height: 5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0.6rem;
  background-color: #000000;

  .sidebar_mobile_icon {
    height: 3.8rem;
    width: 8rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .sidebar_mobile_menu {
    width: 3rem;
    height: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .sidebar_mobile_menu_line {
      height: 0.3rem;
      background-color: #ffffff;
    }
  }

  .sidebar_menu {
    height: 100%;

    .sidebar_menu_panel {
      height: 100%;
      width: 18rem;
      background-color: #f3f3f3;
      position: relative;

      .menu_panel_title {
        height: 5rem;
        padding: 0.3rem 0;
        background-color: #000000;
        width: 100%;

        img {
          margin-left: 1rem;
          height: 3.8rem;
          width: 8rem;
          margin-top: 0.4rem;
        }
      }

      .menu_panel_links {
        font-size: 1.1rem;
        font-weight: bold;
        margin: 0.3rem;
        border-radius: 5px;
        background-color: white;
        color: #414141;

        .link_item {
          padding: 0.8rem 0;
          padding-left: 0.9rem;
          padding-right: 0.8rem;
          border-bottom: 1px solid #f3f3f3;
          position: relative;

          &:hover {
            background-color: #f7f7f7;
          }

          &.link_item_position {
            position: relative;
            padding-left: 2.9rem;
            img {
              position: absolute;
              top: 50%;
              margin-top: -1rem;
              left: 0.9rem;
            }
          }
        }
        .link_item2 {
          padding: 0.8rem 0;
          padding-right: 0.8rem;
          padding-bottom: 0.36rem;
          border-bottom: 1px solid #f3f3f3;
          position: relative;
          .link_item_position {
            position: relative;
            padding-left: 3rem;
            .icon {
              position: absolute;
              top: 50%;
              margin-top: -1rem;
              left: 1rem;
            }
          }
        }

        img {
          width: 1.6rem;
          transform: translateY(0.4rem);
          margin-right: 2px;
        }

        .arrow {
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          border-bottom: 2px solid #bdbdbd;
          border-right: 2px solid #bdbdbd;
          transform-origin: center center;
          transform: rotate(-45deg);
          position: absolute;
          top: 1.3rem;
          right: 0.8rem;
        }
        .wx_code {
          text-align: center;
          margin-right: 0.5rem;
          margin-bottom: 1rem;
          img {
            height: 8rem;
            width: auto;
          }
        }
      }
      .other_oprate {
        margin-top: 0.8rem;
      }
    }

    .active_address {
      // position: absolute;
      bottom: 0;
      text-align: center;
      color: #414141;
      font-size: 0.8rem;
      width: 100%;

      .address_tit {
        font-size: 1rem;
        font-weight: bold;
        padding: 0.26rem;

        img {
          width: 0.6rem;
          transform: translateY(0.06rem);
          margin-right: 0.3rem;
        }
      }

      .address_det {
        p {
          line-height: 1rem;
          padding: 0 1rem;
        }
      }
    }
  }
}
.heightTrans-enter-active,
.heightTrans-leave-active {
  transition: height 0.5s ease-in-out;
}
.heightTrans-enter,
.heightTrans-leave-to {
  height: 0;
}
</style>
<style>
.Zindex {
  z-index: 2500 !important;
}
</style>
